import { useNavigate, useParams } from "react-router-dom";
import ToggleSwitchNew from "../../../@ui/toggle/ToggleSwitchNew";
import { MapView } from "../../../constant/VectorTileLayerType";
import { useMemo } from "react";

const PublicTransportBoundariesToggle = () => {
  const { layer } = useParams();

  const active = useMemo(() => layer === MapView.PT_BOUNDARIES, [layer]);

  const navigate = useNavigate();
  const setActive = () => {
    if (active) {
      navigate("/");
    } else {
      navigate(`/view/${MapView.PT_BOUNDARIES}`);
    }
  };

  return (
    <ToggleSwitchNew
      id="pt-toggle"
      backgroundImage="busstop_g.svg"
      backgroundImageChecked="busstop_w.svg"
      value={active}
      title={active ? "Hide PT Data Map" : "Show PT Data Map"}
      onChange={setActive}
    />
  );
};

export default PublicTransportBoundariesToggle;
